import { TranslationKey } from '@/contexts/translations';
import { MenuItem } from './menu';
import { IconName } from '@/components/material-symbol-link';

export type AppMenuKey = 'profile' | 'information';

type NavigationMenu = {
  title?:
    | TranslationKey
    | {
        label: TranslationKey;
        icon: IconName;
      };
  items: MenuItem[];
};

type NavigationConfig = {
  menus: Record<AppMenuKey, NavigationMenu>;
  menuOrder: readonly AppMenuKey[];
};

const MENU_ITEMS: Record<string, MenuItem> = {
  yourDetails: {
    type: 'link',
    label: 'header.profile.items.profileInformation',
    to: '/profile/information',
  },
  yourDetailsMobile: {
    type: 'link',
    label: 'header.profile.items.profileInformationMobile',
    to: '/profile/information',
  },
  aboutUs: {
    type: 'link',
    label: 'header.information.items.aboutUs',
    to: 'https://www.dermatologistoncall.com/about-us',
    isExternal: true,
  },
  faq: {
    type: 'link',
    label: 'header.information.items.faq',
    to: 'https://www.dermatologistoncall.com/support',
    isExternal: true,
  },
  contactUs: {
    type: 'link',
    label: 'header.information.items.contactSupport',
    to: '/support',
  },
  paymentOptions: {
    type: 'link',
    label: 'header.information.items.paymentOptions',
    to: '/payment-options',
  },
  logoutButton: {
    type: 'logout-button',
  },
};

const DESKTOP_CONFIG: NavigationConfig = {
  menus: {
    profile: {
      title: {
        label: 'header.profile.label',
        icon: 'account_circle',
      },
      items: [MENU_ITEMS.yourDetails, MENU_ITEMS.logoutButton],
    },
    information: {
      title: 'header.information.label',
      items: [
        MENU_ITEMS.aboutUs,
        MENU_ITEMS.faq,
        MENU_ITEMS.contactUs,
        MENU_ITEMS.paymentOptions,
        MENU_ITEMS.logoutButton,
      ],
    },
  },
  menuOrder: ['profile'],
};

const MOBILE_CONFIG: NavigationConfig = {
  menus: {
    profile: {
      items: [MENU_ITEMS.yourDetailsMobile],
    },
    information: {
      items: [MENU_ITEMS.contactUs, MENU_ITEMS.logoutButton],
    },
  },
  menuOrder: ['profile', 'information'],
};

export function getNavigationConfig(isMobile: boolean): NavigationConfig {
  return isMobile ? MOBILE_CONFIG : DESKTOP_CONFIG;
}
